<template>
  <BarChartGenerator
    v-if="chartData"
    ref="chart"
    :data="chartData"
    :options="options"
    :style="computedStyles"
    :plugins="plugins"
  />
</template>

<script setup lang="ts">
/** packages */
import { Bar as BarChartGenerator } from 'vue-chartjs'
import type { TCommon } from '~/src/types/common'

const props = withDefaults(
  defineProps<{
    chartData?: TCommon
    options?: TCommon
    height?: number
    width?: number
    styles?: TCommon
    plugins?: TCommon
  }>(),
  {
    chartData: {},
    options: {},
    height: 400,
    width: 400,
    styles: {},
    plugins: [],
  },
)

const chart = ref<typeof BarChartGenerator | null>(null)

const computedStyles = computed(() => ({
  ...props.styles,
  height: `${props.height}px`,
  width: `${props.width}px`,
}))

watch(
  () => props.chartData,
  (newValue) => {
    if (!chart.value) return
    if (!chart.value.chart) return
    chart.value.chart.data = newValue
    chart.value.chart.update()
    chart.value.chart.resize()
  },
)
</script>
